module.exports = __webpack_public_path__ + "assets/img/videoBg.8afebc59.png";